import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import IntroCard from '../../components/IntroCard';
import IntroModal from '../../components/IntroModal';

import styles from './styles.module.scss';

const Intro = ({ state, setState, roomTypes }) => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();

  const showHelpModal = () => {
    setShowModal(true);
    // Adobe tracking
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.custom = t('tool_ui.button.tell_us_more');
      window._satellite.track('CustomInteraction');
    }
  };

  const onStart = (key, roomKey, roomTitle) => {
    setState({ ...state, key: key, roomKey: roomKey });

    // // Adobe tracking
    if (window.globalLmd) {
      window.lmd = window.globalLmd;
      window.lmd.custom = t(roomTitle);
      window._satellite.track('CustomInteraction');
    }
  };

  return (
    <>
      {showModal && (
        <IntroModal
          setShowModal={setShowModal}
          roomTypes={roomTypes}
          onStart={onStart}
          t={t}
        />
      )}
      <div className={styles.intro__container}>
        <div className={`row ${styles.intro__header}`}>
          <h2>{t('tool_ui.intro.title')}</h2>
        </div>

        <div className={`row ${styles.cards__container}`}>
          {roomTypes.map((room, idx) => (
            <IntroCard room={room} onStart={onStart} key={idx} t={t} />
          ))}
        </div>

        <div className={styles['need-help-desktop']}>
          <button onClick={showHelpModal}>
            {t('tool_ui.button.tell_us_more')}
          </button>
        </div>
        <div className={styles['need-help-mobile']} onClick={showHelpModal}>
          <button>{t('tool_ui.button.tell_us_more')}</button>
        </div>
      </div>
    </>
  );
};

export default Intro;
